export default __webpack_public_path__ + "static/D05-fc13260def3318b60be1ee7fe33f2c13.png";